import React from "react";

const Invoice = () => (
  <svg
    width="24"
    height="30"
    viewBox="0 0 24 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.99996 9.6665H17.6666M6.99996 14.9998H17.6666M13.6666 20.3332H17.6666M4.33329 28.3332H20.3333C21.8061 28.3332 23 27.1393 23 25.6665V4.33317C23 2.86041 21.8061 1.6665 20.3333 1.6665H4.33329C2.86053 1.6665 1.66663 2.86041 1.66663 4.33317V25.6665C1.66663 27.1393 2.86053 28.3332 4.33329 28.3332Z"
      stroke="#252828"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

Invoice.propTypes = {};

Invoice.defaultProps = {};

export default Invoice;
